import React from "react";
import { Link } from "react-router-dom";
import { Amount, Button, Icon, Text } from "@mbank-design/design-system/components";
import { Stack } from "@mbank-design/design-system/components/Stack/Stack";
import { Envelope, Lock, PhoneHandle } from "@mbank-design/design-system/icons";
import ReservedLabel from "../../parts/ReservedLabel";
import { FontSize, FontWeight, LineHeight } from "@mbank-design/design-system/design-tokens/general/typography";
import { Alignment, ButtonType, IconColor, StackAlignment } from "@mbank-design/design-system/enums";
import { useCalculatorContext } from "./DetailsCalculatorProvider";

interface DetailsPageCalculatorMobileProps {
  details: { Reservation?: boolean };
  pageType: string;
  showCalcVisible: boolean;
  installmentPrice: number | null | undefined;
  contactUrl: string;
  literals: any;
  setDarkMode?: boolean;
  setShowCalc: () => void;
  handleClickCalc: () => void;
}

export function DetailsPageCalculatorMobile({
  details,
  pageType,
  showCalcVisible,
  installmentPrice,
  contactUrl,
  literals,
  setDarkMode,
  setShowCalc,
  handleClickCalc
}: DetailsPageCalculatorMobileProps) {
  return (
    <>
      {details.Reservation && (
        <div className="show-on-mobile calc-result-container">
          <div className={`reservation-info-container ${setDarkMode ? "dark" : "white"}`}>
            <ReservedLabel text={"zarezerwowany"} iconType={Lock} color={"zeusBlackUI"} textAs="p" />
            <Text as="p" styledAs="h2" marginTop={16} marginBottom={24}>szukasz podobnego auta?</Text>
            <div className="tiles-wrapper">
              <div>
                <Icon iconComponent={PhoneHandle} primaryColor={IconColor.PRIMARY_CONTRAST} />
                <Text as="p" styledAs="h3" marginTop={8} fontWeight={FontWeight.WEIGHT_600}>zadzwoń</Text>
                <Text as="p" marginBottom={8}>{literals && literals.callusbox_time}</Text>
                <a href={literals && `tel:${literals.callusbox_tel.replace(/ /g, "")}`}>{literals && literals.callusbox_tel}</a>
              </div>
              <div>
                <Icon iconComponent={Envelope} primaryColor={IconColor.PRIMARY_CONTRAST} />
                <Text as="p" styledAs="h3" marginTop={8} fontWeight={FontWeight.WEIGHT_600}>napisz</Text>
                <Text as="p" marginBottom={8}>odpowiedź w 24h</Text>
                <Link to={`/formularz-kontaktowy?${contactUrl}`}>skontaktuj się</Link>
              </div>
            </div>
          </div>
        </div>
      )}
      {details.Reservation && !showCalcVisible && (
        <div className="show-on-mobile calc-result-container">
          <div className={`launch-preview-box ${setDarkMode ? "dark" : "white"}`}>
            <Text as="p" styledAs="h2">finansowanie</Text>
            <Text as="p" marginBottom={8}>zobacz ile kosztowałby Cię ten samochód</Text>
            <Button buttonType={ButtonType.TERTIARY} onClick={() => setShowCalc()}>oblicz ratę miesieczną</Button>
          </div>
        </div>
      )}
      {!details.Reservation ||
        (details.Reservation && showCalcVisible && (
          <div className="show-on-mobile calc-result-container">
            <Stack direction={"column"} spacing={24}>
              <Stack direction={"row"} alignX={StackAlignment.CENTER}>
                <div>
                  <Text fontSize={FontSize.SIZE_12} color={"doveGrayUI"} as={"p"} fontWeight={FontWeight.WEIGHT_600} lineHeight={LineHeight.HEIGHT_16}>
                    rata miesięczna netto
                  </Text>
                </div>
                <div className="amount-container">
                  {installmentPrice != null && (
                    <Text as="p" styledAs="h2">
                      <Amount isFractionPartShown={false} currencyDisplay="symbol" currency="PLN" isFractionPartBolded={true} isFractionPartResized={false} value={installmentPrice} />
                    </Text>
                  )}
                </div>
              </Stack>
              {pageType !== "new" && (
                <Stack direction={"row"} alignX={StackAlignment.CENTER}>
                  <Button buttonType={ButtonType.TERTIARY} onClick={() => handleClickCalc()}>zmień parametry</Button>
                </Stack>
              )}
            </Stack>
          </div>
        ))}
    </>
  );
}

interface DetailsPageCalculatorMobileConnectedProps {
  details: { Reservation?: boolean };
  pageType: string;
  literals: any;
  setDarkMode?: boolean;
  handleClickCalc: () => void;
}

export function DetailsPageCalculatorMobileConnected({
  details,
  pageType,
  literals,
  setDarkMode,
  handleClickCalc
}: DetailsPageCalculatorMobileConnectedProps) {
  const calculator = useCalculatorContext();
  return (
    <DetailsPageCalculatorMobile
      details={details}
      pageType={pageType}
      showCalcVisible={calculator.showCalc}
      installmentPrice={calculator.installmentPrice}
      contactUrl={calculator.urlObject}
      literals={literals}
      setDarkMode={setDarkMode}
      setShowCalc={() => calculator.setShowCalc(true)}
      handleClickCalc={handleClickCalc}
    />
  );
}
